// extracted by mini-css-extract-plugin
module.exports = {"tab":"loader_tab__t8e6Z","grid":"loader_grid__hQ7jM"};